// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".span-ellipsis{cursor:pointer;width:auto;visibility:visible;overflow:hidden;text-overflow:ellipsis;display:-webkit-inline-box;-webkit-line-clamp:1;-webkit-box-orient:vertical}.pop-Style{padding:18px 20px;width:auto!important;min-width:auto;max-width:500px}.pop-Style .realValue{max-height:400px;overflow-y:auto;overflow-x:hidden}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
